<template>
  <div class="NowShowingSlider">
    <div class="" v-for="(festival, festIndex) in MiniFestivals" :key="festIndex">
      <div class="sdHome">
        <div v-if="routeName === '/'" class="col-12 sliderDetails px-0 pr-md-3 px-lg-3">
          <p class="movieCat">
            {{ festival.category_link_name }}

            <span class="txt-link">
              <!-- <router-link class="ml-md-4 mr-2" to>Gog Library</router-link> -->
              <!-- <img :id="'tooltip-mini' + festIndex" src="@/assets/img/svg/info-rd-icon.svg" class="rounded-circle" /> -->
              <!-- <button class="btn btn-danger viewmore-btn mr-4" @click="openModal(festIndex)">Know more</button> -->
              <!-- ToolTip -->
            </span>
            <b-modal v-model="showModal[festIndex]" hide-backdrop >
              <ul>
                <li>
                  {{ festival.category_link_description }}
                </li>
              </ul>
    </b-modal>
            <b-tooltip :target="'tooltip-mini' + festIndex" placement="right">
              
            </b-tooltip>
          </p>
          <!-- <p class="link">
          <router-link :to="{ name: 'nowShowingList' }">(See All)</router-link>
        </p> -->
        </div>
      </div>

      <div class="sd">
        <div v-if="routeName !== '/'" class="col-12 sliderDetails px-0 px-md-3">
          <p class="movieCat">
            {{ festival.category_link_name }}
            <!-- <span class="link ml-2">
            <router-link :to="{ name: 'nowShowingList' }"
              >(See All)</router-link
            >
          </span> -->
          </p>
        </div>
      </div>
      <Slick ref="slick1" :options="movieSlider" class="now-showing">
        <div v-for="(singleMovie, singleindex) in festival.movie_data.data" :key="singleindex">
          <router-link :to="{
            name: 'createScreen',
            params: {
              movie_id: singleMovie.movie_id,
              content_lang_id: singleMovie.content_lang_id
            }
          }">
            <div class="movieSlider-container mx-auto text-center">
              <div class="img-container">
                <router-link :to="{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }">
                  <img alt v-lazy="singleMovie.md_thumbnail_url" class="img-fluid mx-auto banner" />
                </router-link>
              </div>
              <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
                <p class="mb-0 title">{{ singleMovie.movie_title }}</p>
                <ul class="list-inline mb-0 mInfo">
                  <li class="list-inline-item">{{ singleMovie.mf_name }}</li>
                  <li class="list-inline-item">|</li>
                  <li class="list-inline-item">{{ singleMovie.rating }}</li>
                </ul>
              </div>
            </div>
          </router-link>
        </div>
      </Slick>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
import MainServices from "@/services/mainService.js";
import moment from "moment";

export default {
  name: "NowShowingSlider",

  components: {
    Slick
  },

  data() {
    return {
      showModal: [],
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      MiniFestivals: [],
      SubTitle: "Gog Library",
      Title: "",
      routeName: ""
    };
  },
  mounted() {
    this.routeName = window.location.pathname;

    this.getFestivals();
  },
  methods: {
    openModal(index) {
      this.$set(this.showModal, index, true);
    },
    /* getFestivals() {
      MainServices.GetMiniFestivals().then(response => {
        const { data } = response;
        console.log("response", response);
        if (data.status) {
          this.MiniFestivals = data.Records;
        }
      });
    }, */
    getFestivals() {
      MainServices.GetMiniFestivals().then(response => {
        const { data } = response;
        console.log("response >>>>>>>>>>>>>>", response);

        data.Records.sort((a, b) => {
          const aDescription = a.unique_id
          const bDescription = b.unique_id

          // Handle the special case where "New Movies" should be at the top
          if (aDescription == 270365326) return -1;
          if (bDescription == 270365326) return 1;

          // Alphabetical sort for the rest of the items
          if (aDescription < bDescription) return -1;
          if (aDescription > bDescription) return 1;
          return 0;
        });

        if (data.status) {
      this.MiniFestivals = data.Records.filter((item) => {
        return item.unique_id !== 270365326 && item.category_link_movie_id !== 2450;
      }).sort((a, b) => {


        const nameA = a.category_link_name.toUpperCase(); // Ignore case
        const nameB = b.category_link_name.toUpperCase(); // Ignore case

        if (nameA === "NEW RELEASES MOVIES") return -1;
      if (nameB === "NEW RELEASES MOVIES") return 1;
          
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0; // Names are equal
      });
    }

      });
    },
    getNowShowingData: function () {
      let payload = {
        CategoryID: 3,
        Version: "1"
      };
      makeRequest("/GetShows/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.MiniFestivals = res.data.Shows.Movies;
            this.Title = res.data.Categories[2].CategoryName.toUpperCase();
            // this.SubTitle = res.data.shows[3].SubTitle || "Mini Festials";
            // this.MiniFestivals = this.MiniFestivals.filter(show => {
            //   return show.CategoryID == "3";
            // });
            this.$refs.slick4.destroy();
            this.$nextTick(() => {
              this.$refs.slick4.create();
              this.$refs.slick4.goTo(1, true);
            });
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/UpcomingMiniFestivals.vue